var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMapIcon2 = function SvgMapIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.816,
    height: 28.734,
    viewBox: "0 0 30.816 28.734"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 30.816,
    height: 28.734,
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 25.531,
    height: 25.531,
    transform: "translate(2.643 0.561)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 5.862,
    height: 2.082,
    transform: "translate(2.643 26.092)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 2.082,
    height: 5.862,
    transform: "translate(0.56 8.989)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 2.082,
    height: 5.862,
    transform: "translate(28.174 8.989)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 5.862,
    height: 2.082,
    transform: "translate(22.312 26.092)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 2.322,
    cy: 2.322,
    r: 2.322,
    transform: "translate(6.183 17.56)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.322,
    cy: 2.322,
    r: 2.322,
    transform: "translate(19.595 17.56)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })))));
};

export { SvgMapIcon2 as ReactComponent };
export default "data:image/svg+xml;base64,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";